import template from './template.html'

export default {
  bindings: {
    group: '<'
  },
  template
}
